var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZanover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1024 338.51c0 372.37-384.64 643.18-513.91 643.18S0 694 0 330.05C0 171.12 120.81 42.31 269.89 42.31c108 0 201 67.54 244 165 44.76-92.92 135.42-156.56 240.2-156.56 149.1.03 269.91 128.83 269.91 287.76z"
  })));
}
export default SvgZanover;